import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/Layout';
import { Popup } from '../../components/Popup';
import $ from "jquery";

import '../../assets/scss/challenge.scss';
import mascotWalk from '../../assets/images/mascot_walk.png';

const ChallengeFinish = (props) => {
   const navigate = useNavigate();
   const location = useLocation();
   const state = location.state || {}; // { score, total, wrong, details }
   const { score = 0, total = 0, wrong = 0, details = [], chapter = null, words = [], review = false, saved = false } = state;

   const [saveStatus, setSaveStatus] = useState('Saving...');
   const [challengeCount, setChallengeCount] = useState(0);
   const [userName, setUserName] = useState('김두벅');

   const isStudy = location.pathname.startsWith('/Study');

   useEffect(() => {
      // Fetch the name from the server so a renamed profile shows up immediately
      axios.get('/api/auth/profile')
         .then(res => res.data && res.data.name && setUserName(res.data.name))
         .catch(() => { });

      // Finishing a session counts as today's attendance (server decides the date; repeat calls are ignored)
      if (location.state) axios.post('/api/attendance').catch(err => console.error(err));

      // `saved` guards against a duplicate record when this page is refreshed; reviews aren't new records
      if (!isStudy && details.length > 0 && !review && !saved) {
         saveResult();
      } else {
         setSaveStatus(isStudy ? 'Study Complete' : 'No Data');
         if (!isStudy) fetchChallengeCount();
      }

      // Popup logic
      $('.popup-stop .btn-confirm').on('click', function () {
         $('.popup-stop').hide();
         navigate('/Main');
      });
   }, []);

   const saveResult = async () => {
      try {
         const token = localStorage.getItem('token');
         const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

         await axios.post('/api/challenge/result', {
            score, total, wrong_count: wrong, details, chapter
         }, config);

         setSaveStatus('Saved!');
         navigate(location.pathname, { replace: true, state: { ...state, saved: true } });
         fetchChallengeCount(config);
      } catch (err) {
         console.error(err);
         setSaveStatus('Failed to save.');
      }
   };

   const fetchChallengeCount = async (config = {}) => {
      try {
         const token = localStorage.getItem('token');
         const conf = config.headers ? config : (token ? { headers: { Authorization: `Bearer ${token}` } } : {});
         const res = await axios.get('/api/challenge/results', conf);
         setChallengeCount(res.data.length);
      } catch (err) {
         console.error(err);
      }
   };


   return (
      <Layout header containName='finish'>

         <Popup popupName='stop' btn confirmtext='확인'>
            수고하셨습니다!<br />
            메인으로 돌아가시겠습니까?
         </Popup>

         <div className="finish-content-wrap" style={{
            width: '100%',
            maxWidth: '340px',
            margin: '0 auto',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '40px 0'
         }}>
            <div className="finish-icon" style={{ marginBottom: '30px', display: 'block' }}>
               <img src={mascotWalk} alt="" style={{ height: '120px' }} />
            </div>

            <h2 style={{
               fontSize: '28px',
               fontWeight: 'bold',
               color: '#fff',
               lineHeight: '1.4',
               marginBottom: '15px'
            }}>
               {isStudy ? '영단어 학습' : '챌린지 시험'}<br />완료!
            </h2>

            <p style={{
               fontSize: '15px',
               color: 'rgba(255,255,255,0.85)',
               lineHeight: '1.6',
               marginBottom: '40px',
               wordBreak: 'keep-all'
            }}>
               {isStudy
                  ? `${userName}님, 오늘의 성장을 축하드려요! 계속해서 다음 단계로 나아가볼까요?`
                  : `${userName}님, 벌써 ${challengeCount}번째 챌린지 도전입니다. 정말 대단해요!`
               }
            </p>

            {!isStudy && (
               <div className="score-summary" style={{
                  width: '100%',
                  background: 'rgba(255,255,255,0.12)',
                  backdropFilter: 'blur(8px)',
                  padding: '25px',
                  borderRadius: '20px',
                  marginBottom: '40px',
                  border: '1px solid rgba(255,255,255,0.1)'
               }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', color: '#fff', marginBottom: '15px' }}>
                     <span>전체 문항</span>
                     <span style={{ fontWeight: 'bold' }}>{total}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', color: '#fff', marginBottom: '15px' }}>
                     <span style={{ color: '#52d681', fontWeight: 'bold' }}>정답</span>
                     <span style={{ fontWeight: 'bold' }}>{score}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', color: '#fff' }}>
                     <span style={{ color: '#ff6b6b', fontWeight: 'bold' }}>오답</span>
                     <span style={{ fontWeight: 'bold' }}>{wrong}</span>
                  </div>
               </div>
            )}

            <div className="button-stack" style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
               {isStudy ? (
                  <>
                     <button type="button" className="btn btn-white" onClick={() => navigate('/Study/Free')} style={{ height: '54px', borderRadius: '15px' }}>
                        다른 범위 학습하기
                     </button>
                     <button type="button" className="btn btn-white" onClick={() => words.length > 0 ? navigate('/Challenge/View', { state: { reviewWords: words } }) : navigate('/Challenge')} style={{ height: '54px', borderRadius: '15px' }}>
                        방금 배운 단어 테스트
                     </button>
                  </>
               ) : (
                  <button type="button" className="btn btn-white" onClick={() => navigate('/Challenge/Result')} style={{ height: '54px', borderRadius: '15px' }}>
                     내 실력 기록 보기
                  </button>
               )}

               <button type="button" className="btn" onClick={() => navigate('/Main')} style={{
                  height: '54px',
                  background: 'rgba(255,255,255,0.2)',
                  border: '1px solid rgba(255,255,255,0.3)',
                  color: '#fff',
                  borderRadius: '15px',
                  marginTop: '10px'
               }}>
                  메인으로 이동
               </button>
            </div>
         </div>


      </Layout>
   );
};

export default ChallengeFinish;